export function BlockMoreAppsIcon() {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0002 41.9031C21.9269 41.9031 20.8631 41.6348 19.9144 41.1269L13.9344 37.9452C9.59312 35.6356 6.89062 31.141 6.89062 26.2248V15.5106C6.89062 11.5527 9.85188 8.15061 13.7906 7.60436L15.966 7.30728L19.004 5.30436C20.1923 4.52811 21.5723 4.10645 22.9906 4.10645C24.409 4.10645 25.789 4.52811 26.9677 5.30436L30.0056 7.30728L32.181 7.60436C36.1102 8.14103 39.0906 11.5431 39.0906 15.5202V26.2344C39.0906 31.1506 36.3881 35.6452 32.0469 37.9548L26.0669 41.1364C25.1181 41.6348 24.0448 41.9031 22.981 41.9031H23.0002Z"
        fill="url(#paint0_linear_3683_1006)"
      />
      <path
        d="M35.6026 15.3051V26.3164C35.6026 29.9005 33.6284 33.1876 30.4659 34.8743L24.323 38.1422C23.4989 38.583 22.5022 38.583 21.678 38.1422L15.5351 34.8743C12.3726 33.1876 10.3984 29.9005 10.3984 26.3164V15.3051C10.3984 13.168 11.9797 11.3759 14.0784 11.0789L16.5701 10.7339C16.9918 10.6764 17.3847 10.5326 17.7393 10.293L21.0743 8.09844C22.2434 7.33177 23.7576 7.33177 24.9268 8.09844L28.2618 10.293C28.6164 10.523 29.0093 10.6764 29.4309 10.7339L31.9226 11.0789C34.0309 11.3664 35.6026 13.168 35.6026 15.3051Z"
        fill="url(#paint1_linear_3683_1006)"
      />
      <path
        opacity="0.62"
        d="M31.6928 17.0393C31.6928 16.3302 31.2328 15.7264 30.5811 15.5348C30.3798 14.8831 29.7761 14.3943 29.0478 14.3848C28.329 14.3848 27.7253 14.8543 27.5144 15.506C26.8723 15.6977 26.3932 16.2918 26.3836 16.9818C26.3836 17.0681 26.4123 17.1543 26.4219 17.231H26.3644C24.8023 17.231 23.5278 18.0168 22.7228 19.3681V19.301C22.7228 18.2181 21.8698 17.3748 20.7773 17.3748H17.0207C15.9186 17.3748 15.0465 18.1798 14.9315 19.3106L14.5961 23.0768C14.5386 23.6806 14.7303 24.2556 15.1232 24.6773C15.1998 24.7635 15.2861 24.8402 15.3723 24.9073C14.7398 25.2043 14.3086 25.856 14.3086 26.6227C14.3086 27.6289 14.8836 28.156 15.4011 28.5106C16.1486 29.0185 17.289 29.3252 18.3623 29.3252C20.3173 29.3252 21.8315 28.3956 22.5311 26.9293C23.3169 28.4435 24.649 29.3252 26.3644 29.3252C29.1628 29.3252 30.974 26.9677 30.974 23.3164C30.974 21.6968 30.629 20.3264 29.9965 19.301C30.2553 19.0998 30.4565 18.8314 30.5523 18.5152C31.204 18.3331 31.6832 17.7389 31.6832 17.0393H31.6928Z"
        fill="url(#paint2_linear_3683_1006)"
      />
      <path
        d="M18.3725 28.1846C17.5196 28.1846 16.6092 27.945 16.0533 27.5617C15.6221 27.2646 15.4688 27.025 15.4688 26.6321C15.4688 26.2775 15.7179 25.8942 16.1779 25.8942C16.5421 25.8942 16.8104 26.0283 17.1171 26.2008C17.5004 26.4117 17.9029 26.5075 18.4204 26.5075C19.1583 26.5075 19.9538 25.99 19.9538 25.0317C19.9538 24.2171 19.3404 23.6421 18.4683 23.6421C17.9988 23.6421 17.6442 23.7954 17.4333 23.9296C17.1746 24.0829 16.9925 24.1788 16.6475 24.1788C16.3792 24.1788 16.1492 24.0829 15.9863 23.9104C15.8138 23.7283 15.7371 23.4696 15.7658 23.1821L16.1012 19.4158C16.1492 18.8983 16.5421 18.5342 17.0404 18.5342H20.7971C21.2571 18.5342 21.5925 18.86 21.5925 19.3104C21.5925 19.7608 21.2571 20.1154 20.7875 20.1154H17.6729L17.4525 22.4442L17.74 22.3388C18.1233 22.195 18.4779 22.1375 18.8708 22.1375C20.6438 22.1375 21.8321 23.2971 21.8321 25.0221C21.8321 26.91 20.4521 28.175 18.3917 28.175H18.3725V28.1846Z"
        fill="white"
      />
      <path
        d="M26.3619 28.185C24.2344 28.185 22.9023 26.3258 22.9023 23.3358C22.9023 20.3458 24.2632 18.4004 26.3619 18.4004C28.4607 18.4004 29.8215 20.2883 29.8215 23.3358C29.8215 26.3833 28.499 28.185 26.3619 28.185ZM26.3619 20.0104C25.7773 20.0104 24.7998 20.4321 24.7998 23.2879C24.7998 26.1437 25.7773 26.575 26.3619 26.575C26.9465 26.575 27.9048 26.1437 27.9048 23.2879C27.9048 20.4321 27.0615 20.0104 26.3619 20.0104Z"
        fill="white"
      />
      <path
        d="M28.5666 18.0356V17.4127H27.9341C27.7041 17.4127 27.522 17.2306 27.5316 17.0102C27.5412 16.7898 27.7233 16.5981 27.9437 16.6077H28.5762V15.9944C28.5762 15.7452 28.7774 15.5439 29.0362 15.5439C29.2949 15.5439 29.4866 15.7452 29.4866 16.0039V16.6173H30.1191C30.3491 16.6173 30.5312 16.7994 30.5216 17.0294C30.512 17.2594 30.3299 17.4319 30.1095 17.4319H29.4674V18.0452C29.4674 18.2848 29.2662 18.4956 29.0074 18.4956C28.7487 18.4956 28.5474 18.2848 28.557 18.0356H28.5666Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3683_1006"
          x1="23.0002"
          y1="38.5298"
          x2="23.0002"
          y2="5.55353"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E300" />
          <stop offset="0.52" stopColor="#00FC00" stopOpacity="0.89" />
          <stop offset="0.68" stopColor="#17FC00" stopOpacity="0.92" />
          <stop offset="1" stopColor="#8CFC00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3683_1006"
          x1="22.9909"
          y1="38.3436"
          x2="22.9909"
          y2="6.51719"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007700" />
          <stop offset="1" stopColor="#00C800" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3683_1006"
          x1="28.6548"
          y1="14.3848"
          x2="18.899"
          y2="28.0123"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D7F648" stopOpacity="0.8" />
          <stop offset="1" stopColor="#B7F746" stopOpacity="0.5" />
        </linearGradient>
      </defs>
    </svg>
  )
}
